import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogOverlay,
  AlertDialogPortal,
  AlertDialogTitle,
  AlertDialogTrigger
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { LoadingIndicator } from "@/components/ui/loading-indicator";
import { NotificationRow } from "@/components/ui/notification-row";
import useMusioApi from "@/contexts/client/musio-client-context";
import { cn } from "@/utils/utils";
import { type MouseEventHandler } from "react";

const SUCCESS_MSG = "Your plan was canceled."
const ERROR_MSG = "Something went wrong and were unsuccessful cancelling your plan. Please reach out to support if the issue continues"

export default function CancelSubscription({ className }: { className?: string }) {
  const { musioApi } = useMusioApi();
  const { mutate, isPending, isSuccess, isError } = musioApi.useMutation("post", "/user/recurring");

  const handleSubmit: MouseEventHandler<HTMLButtonElement> = async () => {
    mutate({
      body: {
        canceled: true,
      }
    });
  };

  // debug 
  // const upgradePlan = () => {
  //   setSubmitting(true);
  //   setSuccessMsg("Your plan was canceled");
  // };

  const hasNotice = isSuccess || isError;

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <p className={cn("underline cursor-pointer text-sm font-normal mt-2 p-2 text-musio-red", className)}>Cancel Subscription</p>
      </AlertDialogTrigger>

      <AlertDialogPortal>
        <AlertDialogOverlay className="AlertDialogOverlay" />
        <AlertDialogContent className="AlertDialogContent">
          <AlertDialogTitle className="AlertDialogTitle flex items-center justify-between gap-4 p-8 bg-musio-bg">
            <div className="text-[30px] font-semibold text-musio-light-lilac">
              Cancel plan
            </div>
            <AlertDialogCancel asChild>
              <Button
                type="button"
                className="select-none px-8 h-[38px] flex items-center justify-center rounded-full font-bold bg-musio-red text-musio-light-lilac cursor-pointer"
                onClick={() => window.location.reload()}
              >
                <span className="text-sm">Go Back</span>
              </Button>
            </AlertDialogCancel>
          </AlertDialogTitle>

          <AlertDialogDescription className="full centered p-8 bg-musio-bg space-y-4 text-lg text-musio-light-lilac">
            {!hasNotice ?
              "Are you sure?" :
              null
            }
            {hasNotice ?
              <NotificationRow intent="error">
                {isError ? ERROR_MSG : SUCCESS_MSG}
              </NotificationRow> : null
            }
          </AlertDialogDescription>

          <AlertDialogFooter className="p-8 flex items-center justify-center bg-musio-bg">
            {isPending ? <LoadingIndicator /> :
              <Button
                disabled={isSuccess}
                onClick={handleSubmit}
                className={cn(
                  "select-none w-[404px] h-[35px] flex items-center justify-center",
                  "rounded-2xl font-bold text-musio-mid-gray cursor-pointer",
                  "bg-musio-green disabled:opacity-60 disabled:cursor-not-allowed"
                )}
              >
                Submit
              </Button>
            }
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogPortal>
    </AlertDialog>
  );
}

